import Vue from 'vue'
import numeral from 'numeral'

numeral.register('locale', 'custom', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  }
})

numeral.locale('custom');

const app = new Vue()

app.install = function (Vue) {

  Vue.filter('formatNumber', function (value) {
    return numeral(value).format('0,0')
  })

}

export default app



// WEBPACK FOOTER //
// ./client/filters/num.js